// src/DataService/RecipientService.ts
import { apiGet } from "./apiClient";

export type Recipient = { id: string; name: string; email: string };

export const RecipientService = {
  getUsers: async (): Promise<Recipient[]> => {
    return await apiGet("/email/recipients/users");
  },
  getNewsList: async (): Promise<Recipient[]> => {
    return await apiGet("/email/recipients/newslist");
  }
};
